var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "ma-0 pa-0" },
    [
      _vm._l(_vm.tickets, function(ticket, index) {
        return index < 3
          ? _c("v-list-tile-content", { key: index }, [
              _c(
                "div",
                { staticClass: "py-1" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "widget-ticket__item white--text",
                      attrs: { to: _vm.redirectTo(ticket) }
                    },
                    [_vm._v("\n        " + _vm._s(ticket.subject) + "\n      ")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.tickets.length > 0
        ? _c(
            "v-list-tile-content",
            { staticClass: "mt-4 mb-2" },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "white--text none-underline--link widget-ticket__button-see-more",
                  attrs: { to: _vm.path }
                },
                [
                  _c("span", { staticClass: "ma-1" }, [
                    _vm._v(_vm._s(_vm.$t("BTN_SEEMORE")))
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e1c7c3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e1c7c3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-sidebar-widget-ticket/template.html
// module id = null
// module chunks = 